// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.collected-data-board-content {
    margin-top: 2rem;
}

.collected-data-tabs {
    margin-bottom: 4rem;
}

.criteria-table {
    min-width: 350px;
}

.column-header-cell {
    background-color: rgba(3, 87, 166, 0.3);
    font-weight: 600;
    padding: 1em 0.8em 0.8em 0.8em;
    line-height: 0.8em;
}

.column-header-cell-narrow {
    width: 10%;
}

.criteria-table-cell {
    padding: 0.5em;
}

.criteria_element {
    background-color: rgba(3, 87, 166, 0.2);
    margin: 3px;
    padding: 4px 8px;
    border-radius: 15px;
    display: inline-block;
}

.close-saved-search-modal-button {
    position: absolute;
    top: 2rem;
    right: 2rem;
    color: var(--public-portal-primary);
}

.close-saved-search-modal :hover {
    color: var(--public-portal-primary-hover);
}

.saved-search-name {
    margin-bottom: 2rem;
    left: 50%;
    transform: translateX(-50%);
}

.saved-search-name__input {
    text-align: center;
    font-size: 2rem;
}

.delete-record-dialog {
    padding: 2rem;
    border-radius: 15px;
}

.delete-record-dialog__actions {
    justify-content: space-evenly;
}

@media (max-width: 992px) {
    .saved-search-name__input {
        font-size: 1rem;
    }

    .close-saved-search-modal-button {
        top: 0;
        right: 0rem;
    }
}

@media (max-width: 700px) {
    .saved-search-name__input {
        font-size: 1rem;
    }

    .close-saved-search-modal-button {
        top: 0;
        right: 0rem;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/userCollectedData/UserCollectedData.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,uCAAuC;IACvC,gBAAgB;IAChB,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,uCAAuC;IACvC,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,mCAAmC;AACvC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,mBAAmB;IACnB,SAAS;IACT,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,MAAM;QACN,WAAW;IACf;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,MAAM;QACN,WAAW;IACf;AACJ","sourcesContent":[".collected-data-board-content {\n    margin-top: 2rem;\n}\n\n.collected-data-tabs {\n    margin-bottom: 4rem;\n}\n\n.criteria-table {\n    min-width: 350px;\n}\n\n.column-header-cell {\n    background-color: rgba(3, 87, 166, 0.3);\n    font-weight: 600;\n    padding: 1em 0.8em 0.8em 0.8em;\n    line-height: 0.8em;\n}\n\n.column-header-cell-narrow {\n    width: 10%;\n}\n\n.criteria-table-cell {\n    padding: 0.5em;\n}\n\n.criteria_element {\n    background-color: rgba(3, 87, 166, 0.2);\n    margin: 3px;\n    padding: 4px 8px;\n    border-radius: 15px;\n    display: inline-block;\n}\n\n.close-saved-search-modal-button {\n    position: absolute;\n    top: 2rem;\n    right: 2rem;\n    color: var(--public-portal-primary);\n}\n\n.close-saved-search-modal :hover {\n    color: var(--public-portal-primary-hover);\n}\n\n.saved-search-name {\n    margin-bottom: 2rem;\n    left: 50%;\n    transform: translateX(-50%);\n}\n\n.saved-search-name__input {\n    text-align: center;\n    font-size: 2rem;\n}\n\n.delete-record-dialog {\n    padding: 2rem;\n    border-radius: 15px;\n}\n\n.delete-record-dialog__actions {\n    justify-content: space-evenly;\n}\n\n@media (max-width: 992px) {\n    .saved-search-name__input {\n        font-size: 1rem;\n    }\n\n    .close-saved-search-modal-button {\n        top: 0;\n        right: 0rem;\n    }\n}\n\n@media (max-width: 700px) {\n    .saved-search-name__input {\n        font-size: 1rem;\n    }\n\n    .close-saved-search-modal-button {\n        top: 0;\n        right: 0rem;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
